import { Injectable } from '@angular/core';

import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpResponse,
  HttpErrorResponse,
} from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { EncrDecrService } from '../../../@core/utils/encdec.service';
import { SessionExpiryService } from '../../../@core/services/session-expiry.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(
    private EncrDecr: EncrDecrService,
    private sessionExpiry: SessionExpiryService,
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    const token = sessionStorage.getItem('x');
    const headers: Record<string, string> = {};
    if (token) {
      headers.Authorization = token;
    }

    if (request.body !== null && request.body !== undefined) {
      request = request.clone({
        setHeaders: headers,
        body: { pld: this.EncrDecr.set(request.body) },
      });
    } else {
      request = request.clone({
        setHeaders: headers,
      });
    }

    return next.handle(request).pipe(
      map((event) => {
        if (event instanceof HttpResponse) {
          const body = event.body;
          if (body && typeof body === 'object' && Object.prototype.hasOwnProperty.call(body, 'pld')) {
            event = event.clone({
              body: JSON.parse(this.EncrDecr.get(body.pld)),
            });
          }
        }
        return event;
      }),
      catchError((error: HttpErrorResponse) => {
        if (error && error.hasOwnProperty('status') && error.status === 556) {
          this.sessionExpiry.showSessionExpiredModal();
        }
        return throwError(() => error);
      }),
    );
  }
}
